<script>
import { BPaginationNav } from "bootstrap-vue";

export default {
  extends: BPaginationNav
};
</script>